//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: String,
    save: Function,
    saveLabel: {
      type: String,
      default: 'salvar',
    },
    mdOpenFrom: String,
    mdCloseTo: String,
    mdEscToClose: {
      type: Boolean,
      default: true,
    },
    mdClickOutsideToClose: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.onClose();
      }
    },
  },
  methods: {
    open() {
      this.dialog = true;
      this.onOpen();
    },
    close() {
      this.dialog = false;
    },
    defaultClose() {
      this.$emit('GENERICMODAL_DEFAULT_CLOSE');
      this.close();
    },
    defaultSave() {
      this.$emit('GENERICMODAL_DEFAULT_SAVE');
      if (!this.save) {
        this.close();
      } else {
        this.save();
      }
    },
    onOpen() {
      this.$emit('GENERICMODAL_OPEN');
    },
    onClose() {
      this.$emit('GENERICMODAL_CLOSE');
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/generico/GenericModal.vue?vue&type=script&lang=js&